export default __webpack_public_path__ + "static/media/FunStory-android.1e5accc3.png";